import getQuickAddViewState from '../selectors/getQuickAddViewState';
import { mutator } from 'satcheljs';
import {
    setFolderId,
    setIsFocused,
    setIsShown,
    setSubject,
    setLinkedEmailEntity,
    setExtractionId,
} from '../actions/quickAddActions';

export const setSubjectMutator = mutator(setSubject, actionMessage => {
    getQuickAddViewState().subject = actionMessage.subject;
});

export const setFolderIdMutator = mutator(setFolderId, actionMessage => {
    let folderId: string = actionMessage.folderId;
    getQuickAddViewState().folderId = folderId;
});

export const setIsShownMutator = mutator(setIsShown, actionMessage => {
    getQuickAddViewState().isShown = actionMessage.isShown;
});

export const setIsFocusedMutator = mutator(setIsFocused, actionMessage => {
    getQuickAddViewState().isFocused = actionMessage.isFocused;
});

export const setLinkedEmailMutator = mutator(setLinkedEmailEntity, actionMessage => {
    getQuickAddViewState().linkedEmailEntity = actionMessage.linkedEmailEntity;
});

export const setExtractionIdMutator = mutator(setExtractionId, actionMessage => {
    getQuickAddViewState().extractionId = actionMessage.extractionId;
});
